<template>
  <div>
    <el-upload
      :disabled="disabled"
      class="avatar-uploader"
      :on-progress="handleProgress"
      :action="minioUploadUrl"
      :accept = "acceptVal ? acceptVal : '.jpg, .jpeg, .png, .gif, .JPG, .JPEG, .PNG, .GIF'"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload">
      <div v-if="imageUrl" class="img-box" @mouseenter="mouseenter" @mouseleave="mouseleave">
        <img :src="imageUrl" class="avatar">
        <div class="box-icon" v-if="showIcon">
          <i class="icon el-icon-zoom-in" @click="imgBigShow($event)"></i>
        </div>
      </div>
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      <!-- 上传进度条 -->
      <el-progress
        v-if="percent > 0 && percent < 100"
        :percentage="percent"
        :show-text="true"
        style="margin-top: 10px;"
      ></el-progress>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="imageUrl" class="avatar" alt="">
    </el-dialog>
  </div>
</template>
<script>

	import { config, } from '@/units/request.js'
  export default {
    name: 'singleUpload',
    props: {
      acceptVal:String,
      value: String,
      sizeData:Object,
      disabled: Boolean
    },
    computed: {
    },
    data() {
      return {
        dialogVisible: false,
        minioUploadUrl: '',
        imageUrl: '',
        showIcon:false,
        clickOk: true,
        percent: 0 // 新增进度
      };
    },
    created(){
			this.minioUploadUrl = config.baseUrl + 'v1/upload/pic'
    },
    watch:{
      'value': function(val){
        this.imageUrl = val
      }
    },
    methods: {
      handleProgress(event, file, fileList) {
        let percentCompleted = parseInt(Math.floor(event.loaded * 100 / event.total), 10);
        this.percent = percentCompleted; // 更新进度
        console.log(`上传进度：${percentCompleted}%`);
      },
      mouseleave(){
        this.showIcon = false
      },
      mouseenter(){
        this.showIcon = true
      },
      imgBigShow(event){
        this.dialogVisible = true
        event.stopPropagation()
      },
      handleAvatarSuccess(res) {
        console.log(res)
        this.imageUrl = res.entity.fileUrl;
        this.$emit('getImgData', res.entity.fileUrl)
      },
      beforeAvatarUpload() {
      }
    }
  }
</script>
<style scoped>
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.el-dialog .avatar{
  width:100%;
  height: auto;
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.img-box{
  position: relative;
}
.img-box .box-icon{
  width:100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.img-box .icon{
  cursor: pointer;
  position: absolute;
  color:#fff;
  font-size: 20px;
  left: 50%;
  top:50%;
  margin-left: -10px;
  margin-top: -10px;
  z-index: 2;
}
</style>


